export default {
  baseUrl: "https://msc-opt.kyomu.cornflow.com",
};
